import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent implements OnInit, OnDestroy {
    user: any = null;
    isHandset: boolean = false;
    private breakpointSubscription: Subscription | undefined;

    @ViewChild('drawer') drawer!: MatSidenav;

    constructor(
        private authService: AuthService,
        private router: Router,
        private breakpointObserver: BreakpointObserver
    ) { }

    ngOnInit(): void {
        // ユーザー情報の取得（ログイン状態の確認に使用）
        this.authService.fetchCurrentUser().subscribe({
            next: (data) => {
                this.user = data;
            },
            error: (err) => {
                console.error('User fetch failed', err);
                this.router.navigate(['/login']);
            }
        });

        // 画面サイズの監視（スマートフォン表示などの切り替えに使用）
        this.breakpointSubscription = this.breakpointObserver.observe(Breakpoints.Handset)
            .subscribe(result => {
                this.isHandset = result.matches;
            });
    }

    ngOnDestroy(): void {
        // メモリの無駄遣いを防ぐための後処理
        if (this.breakpointSubscription) {
            this.breakpointSubscription.unsubscribe();
        }
    }

    onLogout(): void {
        this.authService.logout().subscribe({
            next: () => {
                window.location.href = '/login';
            },
            error: () => {
                window.location.href = '/login';
            }
        });
    }
}